import { render } from "./AppNavigationHeaderNewEvent.vue?vue&type=template&id=35b264f5"
import script from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__